import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Label } from '../components/ui/label';
import { authService } from '../lib/api';
import { useNavigate } from 'react-router-dom';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [debugToken, setDebugToken] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      alert('Veuillez saisir votre email');
      return;
    }

    try {
      setLoading(true);
      const response = await authService.forgotPassword(email);
      setSuccess(true);
      
      // En développement, afficher le token pour tester
      if (response.debug_token) {
        setDebugToken(response.debug_token);
      }
    } catch (error) {
      console.error('Erreur:', error);
      // On affiche quand même le succès pour ne pas révéler si l'email existe
      setSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="text-center mb-4">
            <div className="text-5xl mb-4">🔐</div>
            <CardTitle className="text-2xl font-bold text-gray-900">
              Mot de passe oublié ?
            </CardTitle>
            <p className="text-sm text-gray-600 mt-2">
              Entrez votre adresse email pour recevoir un lien de réinitialisation
            </p>
          </div>
        </CardHeader>
        <CardContent>
          {!success ? (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="email">Adresse Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="votre.email@entreprise.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                  className="mt-1"
                />
              </div>

              <Button 
                type="submit" 
                className="w-full"
                disabled={loading}
              >
                {loading ? '⏳ Envoi en cours...' : '📧 Envoyer le lien'}
              </Button>

              <div className="text-center">
                <button
                  type="button"
                  onClick={() => navigate('/login')}
                  className="text-sm text-blue-600 hover:text-blue-800"
                >
                  ← Retour à la connexion
                </button>
              </div>
            </form>
          ) : (
            <div className="space-y-6">
              <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
                <div className="text-4xl mb-3">✅</div>
                <h3 className="font-medium text-green-900 mb-2">
                  Email envoyé !
                </h3>
                <p className="text-sm text-green-800">
                  Si un compte existe avec cet email, vous recevrez un lien de réinitialisation dans quelques instants.
                </p>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-blue-900">
                  <strong>📧 Vérifiez votre boîte email</strong>
                </p>
                <ul className="text-sm text-blue-800 mt-2 space-y-1">
                  <li>• Le lien est valide pendant 1 heure</li>
                  <li>• Vérifiez aussi vos spams</li>
                  <li>• Si vous ne recevez rien, réessayez</li>
                </ul>
              </div>

              {debugToken && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                  <p className="text-sm text-yellow-900 font-medium mb-2">
                    🛠️ Mode Développement
                  </p>
                  <p className="text-xs text-yellow-800 mb-2">
                    Token généré (SMTP non configuré) :
                  </p>
                  <div className="bg-white p-2 rounded border border-yellow-300">
                    <code className="text-xs break-all">{debugToken}</code>
                  </div>
                  <Button
                    size="sm"
                    className="mt-3 w-full"
                    onClick={() => navigate(`/reset-password?token=${debugToken}`)}
                  >
                    Tester la réinitialisation
                  </Button>
                </div>
              )}

              <div className="text-center">
                <Button
                  variant="outline"
                  onClick={() => navigate('/login')}
                  className="w-full"
                >
                  ← Retour à la connexion
                </Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;
